import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { ScrivitoImageWidgetList } from "scrivito/scrivito-image/ScrivitoImageWidgetList"
import { Button } from "shared/ui/buttons/Button"
import { Image } from "shared/ui/image/Image"

import { useProductPageContext } from "../context/ProductPageContext"

interface ProductPageImageProps extends React.HTMLAttributes<HTMLDivElement> {}

export const ProductPageImage = React.memo(
  React.forwardRef<HTMLDivElement, ProductPageImageProps>(
    ({ className, children, ...props }, ref) => {
      const { t } = useTranslation()
      const {
        productObj,
        productBaseVariantObj,
        productImageUrl,
        onZoomProductImage
      } = useProductPageContext()

      const content =
        children ||
        (productImageUrl ? (
          <Image>
            <img src={productImageUrl} alt="" />
          </Image>
        ) : (
          <ScrivitoImageWidgetList
            content={productBaseVariantObj || productObj}
            attribute="imageWidgets"
          />
        ))

      return (
        <div
          ref={ref}
          className={classNames("product-page__image", className)}
          {...props}
        >
          {onZoomProductImage ? (
            <Button
              className="product-image__zoom-button"
              style={{ cursor: "zoom-in" }}
              onClick={onZoomProductImage}
              label={t("Product.ZoomImage")}
            >
              {content}
            </Button>
          ) : (
            content
          )}
        </div>
      )
    }
  )
)
